// src/pages/usa/colorado/Georgetown.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Georgetown ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function GeorgeTown() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__georgetownBackRouteSet) {
      window.__georgetownBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Georgetown, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>🏞️ Discover Georgetown, Colorado</h2>

            <p>
              Georgetown is a small mountain town nestled in the Rocky Mountains, known for its rich history,
              stunning scenery, and outdoor adventures. Founded during the Colorado Silver Boom in the late 19th
              century, it has preserved much of its historic charm — making it a delightful destination for both
              history lovers and nature seekers.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              The drive from Denver to Georgetown takes about 45 minutes to 1 hour, depending on traffic and road
              conditions. It’s one of the easiest mountain towns to reach from the Front Range.
            </p>

            {/* 🌟 PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Georgetown Train:</strong> A gorgeous scenic ride through the mountains aboard a historic
                  steam locomotive. The train winds through rugged terrain and arrives in Silver Plume, where you can
                  explore a small museum before returning.<br />
                  <a
                    href="https://www.google.com/maps?q=39.700955807104386,-105.70671553102605"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>The Lake:</strong> A beautiful spot for picnics, fishing, and paddle boating — especially
                  peaceful in the early morning.<br />
                  <a
                    href="https://www.google.com/maps?q=39.72705490792831,-105.69303902338635"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Mt. Bierstadt:</strong> One of Colorado’s most popular 14ers, offering a relatively
                  accessible summit with stunning views.<br />
                  <a
                    href="https://www.google.com/maps?q=39.5961543961408,-105.71015830850595"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            {/* 🥾 HIDDEN GEMS */}
            <h3>🥾 Other Hidden Gems</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Square Top Lakes Trail:</strong> Scenic alpine hike with two lakes and panoramic views.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Silver Dale Historic Trail:</strong> Quiet walk through Georgetown’s mining past.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Guanella Pass Scenic Byway:</strong> A breathtaking drive with wildflowers, wildlife, and
                  sweeping mountain views.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Georgetown Energy Museum:</strong> A free museum inside a working hydroelectric plant.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hotel de Paris Museum:</strong> A restored 19th‑century hotel offering guided tours.
                </div>
              </li>
            </ul>

            {/* 🛏️ PLACES TO STAY */}
            <h3>🛏️ Places to Stay in Georgetown</h3>

            <p>
              I haven’t stayed overnight in Georgetown myself, but these options are close to the train or lake and
              consistently earn solid reviews:
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Hotel Chateau Chamonix:</strong> French‑inspired charm with private hot tubs.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Georgetown Mountain Inn:</strong> Cozy alpine vibe with indoor pool and hot tub.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Microtel Inn & Suites:</strong> Modern, pet‑friendly, and close to lake trails.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Rose Street Bed & Breakfast:</strong> Historic 1882 home near Main Street.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Clear Creek Inn:</strong> Family‑run and walkable to shops and the railroad.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>St. James Hotel:</strong> Renovated gem with vintage flair downtown.
                </div>
              </li>
            </ul>

            {/* AFFILIATE BLOCK */}
           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                       <div className="affiliate-block">
                         <AffiliateExpedia />
                         <AffiliateBooking />
                         <AffiliateTrip />
                       </div>

            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos I took from Georgetown. Set the quality to 1080p or higher.</p>

            <p>
              <a
                href="https://youtu.be/EuSKH12bPX4?si=NaQCln_uW6L1vpQY"
                target="_blank"
                rel="noopener noreferrer"
              >
                Georgetown Frozen Lake
              </a>
              <br />
              <a
                href="https://youtu.be/y0DU6oVBWS0?si=WfACGbTSk0ioKjAc"
                target="_blank"
                rel="noopener noreferrer"
              >
                Georgetown Train
              </a>
              <br />
              <a
                href="https://youtu.be/5Hw-ppCujPg?si=ZH-4LFcRD7NwocrG"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mt. Bierstadt
              </a>
              <br />
              <a
                href="https://youtu.be/MyDPoubtvbA?si=R8D5rHaJrE1VQVID"
                target="_blank"
                rel="noopener noreferrer"
              >
                Georgetown Town
              </a>
              <br />
              <a
                href="https://youtu.be/vGYOWjbLIK8?si=FBej2bRxX2roIJwd"
                target="_blank"
                rel="noopener noreferrer"
              >
                360 View of Georgetown
              </a>
              <br />
              <a
                href="https://youtu.be/KugdbCkeoE4?si=OcJ5jqHh400-5txb"
                target="_blank"
                rel="noopener noreferrer"
              >
                360 View of Georgetown Train Ride
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/y0DU6oVBWS0?si=WfACGbTSk0ioKjAc"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/georgetown/railroad.jpg"
                alt="Georgetown Train Video"
              />
            </a>

            <a
              href="https://youtu.be/MyDPoubtvbA?si=R8D5rHaJrE1VQVID"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/georgetown/thetown.jpg"
                alt="Georgetown Town Video"
              />
            </a>

            <img src="/images/usa/colorado/georgetown/train.jpg" alt="Train View" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/train5.jpg" alt="Train View" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/gate.jpg" alt="Train Gate" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/train6.jpg" alt="Train View" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/lake2.jpg" alt="Lake View" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/lakeview.jpg" alt="Lake View" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/alpinehose.jpg" alt="Alpine Hose Building" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/town.jpg" alt="Town" loading="lazy" />
            <img src="/images/usa/colorado/georgetown/houseintown.jpg" alt="House in Town" loading="lazy" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
